import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/sections/Header";
import Footer from "@/sections/Footer";
import FloatingCTA from "@/sections/FloatingCTA";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import LexOSPage from "@/pages/LexOSPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
void CaseStudiesPage; // Case Studies page is hidden until real client attribution is finalized
import ReportPage from "@/pages/ReportPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiesPage from "@/pages/CookiesPage";

// Scroll to top on route change (or to hash if present)
const ScrollHandler = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
};

const Layout = ({ children }) => (
    <div data-testid="lexafide-home" id="top" className="relative bg-[var(--cream)] text-[var(--ink)] [overflow-x:clip]">
        <Header />
        {children}
        <Footer />
        <FloatingCTA />
    </div>
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollHandler />
                <Layout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/pricing" element={<PricingPage />} />
                        <Route path="/platform" element={<LexOSPage />} />
                        {/* /case-studies hidden — see CaseStudiesPage import comment */}
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/report" element={<ReportPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/cookies" element={<CookiesPage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
